/**
 * Single source of truth for all public-facing email addresses.
 *
 * Routing logic:
 *  - General website inquiries        -> hello@theiyare.com
 *  - Personal correspondence          -> me@theiyare.com
 *  - Speaking / workshops / booking   -> booking@theiyare.com
 *  - Podcast guests / media / collab  -> podcast@theiyare.com
 *
 * To change any address, edit this file ONLY — every CTA across the site
 * imports from here.
 */

export const EMAILS = {
  hello: "hello@theiyare.com",
  me: "me@theiyare.com",
  booking: "booking@theiyare.com",
  podcast: "podcast@theiyare.com",
};

/** Default subject lines per inbox. */
export const SUBJECTS = {
  hello: "Website Inquiry",
  me: "Personal Correspondence",
  booking: "Speaking Inquiry",
  podcast: "Podcast Collaboration",
};

/**
 * Build a mailto: link with a prepopulated subject.
 *
 * @param {("hello"|"me"|"booking"|"podcast")} key
 * @param {string} [subjectOverride] - optional context-specific subject line
 */
export const mailtoLink = (key, subjectOverride) => {
  const to = EMAILS[key];
  const subject = encodeURIComponent(subjectOverride || SUBJECTS[key]);
  return `mailto:${to}?subject=${subject}`;
};
